import { render, staticRenderFns } from "./chosen-dispatchers-statement.component.vue?vue&type=template&id=62362690"
import script from "./chosen-dispatchers-statement.component.vue?vue&type=script&lang=js"
export * from "./chosen-dispatchers-statement.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports